import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import geonamesImg from '../assets/images/geonames.png';
import digitalTwinImg from '../assets/images/digitalTwin.png';
import ksacorsImg from '../assets/images/KSA-CORS-APP.png';
import networkImg from '../assets/images/network.svg';
import geocatalog from '../assets/images/ksamapbeta.png';
import geoid21Img from '../assets/images/KSA-GEOID21.png';
import grfTransformationImg from '../assets/images/ksa-grf-transformation-tool.png';
import vrfTransformationImg from '../assets/images/transformation-tool-for-vertical-reference-frame-and-geoid-heights.png';
import arrowGreen from '../assets/icons/arrow-green.svg';
import ksaMapImg from'../assets/images/geocatalog.png';
import maritime from  '../assets/images/maritime.png';
import enc1 from  '../assets/images/ENC1.png'




function GeospatialApplications() {
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState(false);

  const handleReadMore = () => {
    setShowMore(true);
  };

  return (
    <div style={{ background: 'linear-gradient(135deg, rgba(3, 52, 68, 1) 0%, rgba(3, 52, 68, 0.9) 50%, rgba(3, 52, 68, 1) 100%)' }}>
      <div className="space" style={{ height: '100px' }}></div>

      <h2 className="text-center mb-5" style={{ color: '#fff' }}>
      {t('geospatial_applications')}
            </h2>

      <section className="services">
        <div className="service-container-sub">
          {/* Geographical Names Explorer */}
          <div className="service-card-sub">
          <a href={t('geographical_names_explorer_url')} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <div className="image-container">
                <img src={geonamesImg} alt="Geographical Names Explorer" />
                <div className="icon-overlay">
                  <img src={arrowGreen} alt="Arrow Icon" />
                </div>
                <div className="floating-text">
                  <h3>{t('Geographical-Names-Explorer')}</h3>
                </div>
              </div>
            </a>
            <div className="text-container">
              <p>{t('Geographical-Names-Explorer-subtitle')}</p>
            </div>
          </div>

          {/* Digital Twin */}
          {/* <div className="service-card-sub">
          <a href={t('digital-twin_url')} target="_blank" rel="noopener noreferrer"style={{ textDecoration: 'none' }}>

              <div className="image-container">
                <img src={digitalTwinImg} alt="Digital Twin" />
                <div className="icon-overlay">
                  <img src={arrowGreen} alt="Arrow Icon" />
                </div>
                <div className="floating-text">
                  <h3>{t('digital-twin-sub')}</h3>
                </div>
              </div>
            </a>
            <div className="text-container">
              <p>{t('digital-twin-subtitle')}</p>
            </div>
          </div> */}

           {/* Data Catalog */}
           <div className="service-card-sub">
          <a href={t('geocatalog_url')} target="_blank" rel="noopener noreferrer"style={{ textDecoration: 'none' }}>
                  <div className="image-container">
                    <img src={geocatalog} alt="Data Catalog" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('geocatalog')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('geocatalog_subtitle')}</p>
                </div>
              </div>

               {/* KSA CORS */}
              <div className="service-card-sub">
                <a href={t('KSA-CORS-url')} target="_blank" rel="noopener noreferrer"style={{ textDecoration: 'none' }}>
                  <div className="image-container">
                    <img src={ksacorsImg} alt="KSA CORS" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('KSA-CORS')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('KSA-CORS-subtitle')}</p>
                </div>
              </div>

          {/* Other hidden cards */}
          {showMore && (
            <>
             

              {/* National Tide Gauge Network */}
              <div className="service-card-sub">
              <a href={t('NTGN-url')} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <div className="image-container">
                    <img src={networkImg} alt="National Tide Gauge Network" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('NTGN-App')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('NTGN-App-subtitle')}</p>
                </div>
              </div>

             
              {/* ksa-geoid-calculator */}
              <div className="service-card-sub">
              <a href={t('KSA-GEOID_Height_Calculator_url')} target="_blank" rel="noopener noreferrer"style={{ textDecoration: 'none' }}>
              <div className="image-container">
                    <img src={geoid21Img} alt="Data Catalog" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('ksa-geoid-calculator')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('ksa-geoid-calculator-subtitle')}</p>
                </div>
              </div>
              {/* Saudi_Map */}
              {/* <div className="service-card-sub">
              <a href={t('ksa-map-url')} target="_blank" rel="noopener noreferrer"style={{ textDecoration: 'none' }}>
                  <div className="image-container">
                    <img src={ksaMapImg} alt="Data Catalog" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('Saudi_Map')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('Saudi_Map_description')}</p>
                </div>
              </div> */}
              {/* KSA-GRF Transformation Tool */}
              <div className="service-card-sub">
              <a href={t('Online-GRF-TT_url')} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <div className="image-container">
                    <img src={grfTransformationImg} alt="Data Catalog" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('Online-GRF-TT')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('Online-GRF-TT-subtitle')}</p>
                </div>
              </div>
              {/* KSA-VRF Transformation Tool */}
              <div className="service-card-sub">
              <a href={t('Online-VRF-TT_url')} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <div className="image-container">
                    <img src={vrfTransformationImg} alt="Data Catalog" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('Online-VRF-TT')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('Online-VRF-TT-subtitle')}</p>
                </div>
              </div>
               {/* ENC Viewer */}
              {/*  <div className="service-card-sub">
              <a href="https://apps.geoportal.sa/maritime/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <div className="image-container">
                    <img src={enc1} alt="Data Catalog" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('MarineSDI_App1')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('MarineSDI_App1_subtitle')}</p>
                </div>
              </div> */}
               {/* Maritime Chart builder 
               <div className="service-card-sub">
              <a href="https://apps.geoportal.sa/ccb/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <div className="image-container">
                    <img src={enc} alt="Data Catalog" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('MarineSDI_App2')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('MarineSDI_App2_subtitle')}</p>
                </div>
              </div>*/}
              {/* Hydrography Viewer */}
             {/*  <div className="service-card-sub">
              <a href="https://apps.geoportal.sa/hydrographyviewer" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <div className="image-container">
                    <img src={maritime} alt="Data Catalog" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('MarineSDI_App3')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('MarineSDI_App3_subtitle')}</p>
                </div>
              </div> */}
            </>
          )}

          {/* Read More Button */}
          {!showMore && (
            <button className="geospatial-button" onClick={handleReadMore}>
              {t('read-more')}
            </button>
          )}
        </div>
      </section>

      <div className="space" style={{ height: '100px' }}></div>
    </div>
  );
}

export default GeospatialApplications;
